import React, { useContext, useEffect } from 'react';
import { DataContext } from 'opidcore';

const MagicalState = ({to, setter})=>{
    const bound = useContext(DataContext);

    useEffect( ()=>{
        bound.magicalState(to, setter);
    },[bound]);

    return null;
}

export { MagicalState };